import React from 'react';
import { Box, Typography, Breadcrumbs, Link, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SectionHeader = ({
    title,
    subtitle,
    breadcrumbs = [],
    actions = [],
    mb = 4
}) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ mb }}>
            {/* Breadcrumbs */}
            {breadcrumbs.length > 0 && (
                <Breadcrumbs sx={{ mb: 3 }}>
                    {breadcrumbs.map((crumb, index) => (
                        index === breadcrumbs.length - 1 ? (
                            <Typography
                                key={index}
                                color="text.primary"
                                sx={{ color: '#0e141b', fontSize: '0.875rem', fontWeight: 500 }}
                            >
                                {crumb.label}
                            </Typography>
                        ) : (
                            <Link
                                key={index}
                                color="inherit"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(crumb.path);
                                }}
                                sx={{ color: '#4e7397', fontSize: '0.875rem', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                            >
                                {crumb.label}
                            </Link>
                        )
                    ))}
                </Breadcrumbs>
            )}

            {/* Header Title and Actions */}
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', md: 'center' },
                gap: 2
            }}>
                <Box sx={{ maxWidth: '800px' }}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#0e141b',
                            fontSize: { xs: '1.875rem', md: '2.25rem' },
                            fontWeight: 900,
                            mb: 1,
                            letterSpacing: '-0.033em',
                        }}
                    >
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography component="div" sx={{ color: '#4e7397', fontSize: '1rem' }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>

                {actions.length > 0 && (
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                        {actions.map((action, index) => (
                            <Button
                                key={index}
                                variant={action.variant || "contained"}
                                startIcon={action.icon}
                                onClick={action.onClick}
                                sx={{
                                    bgcolor: action.variant === 'outlined' ? 'transparent' : (action.color || '#800020'),
                                    color: action.variant === 'outlined' ? (action.color || '#4e7397') : '#ffffff',
                                    borderColor: action.variant === 'outlined' ? (action.borderColor || '#d0dbe7') : 'transparent',
                                    '&:hover': {
                                        bgcolor: action.variant === 'outlined' ? 'rgba(128, 0, 32, 0.04)' : (action.hoverColor || '#600010'),
                                        borderColor: action.variant === 'outlined' ? '#800020' : 'transparent',
                                        color: action.variant === 'outlined' ? '#800020' : '#ffffff',
                                    },
                                    borderRadius: '0.5rem',
                                    px: 3,
                                    py: 1.25,
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {action.label}
                            </Button>
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default SectionHeader;
